import { editor } from '@/instance';

export const useAddImageLayer = () => {
    return {
        /**
         * 添加图片素材
         *
         * @param params - 参数
         */
        async add({
            id,
            url,
            width,
            height,
            isPhoto = false,
            showLoading = true,
            byMousePosition,
            fixedCenter = false,
            fitWithStage = true,
        }: {
            id: number | string;
            url: string;
            width?: number;
            height?: number;
            isPhoto?: boolean;
            showLoading?: boolean;
            byMousePosition?: boolean;
            fixedCenter?: boolean;
            fitWithStage?: boolean;
        }) {
            try {
                if (showLoading) {
                    editor.tip.showMask({
                        loading: true,
                        text: '加载中',
                    });
                }
                const result = await editor.imageLayer.addImageLayer(
                    {
                        url,
                        width,
                        height,
                        isPhoto,
                        byMousePosition,
                        materialId: `${id}`,
                        fixedCenter,
                    },
                    fitWithStage,
                );

                return result;
            } catch (e) {
                console.log(e);
                if (showLoading) editor.tip.hideMask();
            } finally {
                if (showLoading) editor.tip.hideMask();
            }
        },
    };
};
